<template lang="html">
  <div id="header" class="parallaxbg">
    <div class="section-overly" >
      <div class="outer-text">
        <div class="middle-text">
          <div class="inner-text">
            <div class="modal-wrap login-page">
              <div class="modal-bodies">
                 <div class="downtime-banner modal-body text-bold" v-if="showDownTimeWarning">
                  {{showDownTimeMessage }} <a :href="'mailto:'+showDownTimeSubMessage">{{ showDownTimeSubMessage }}</a>
                </div>
                <div class="row modal-body">
                  <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 no-padding">
                    <div class="login-wrap" style="border-radius: 12px !important;">
                      <div class="login-header">
                        <img :src="Logo" class="img-responsive" alt=""/>
                      </div>
                      <div v-if="showOTPForm">
                        <div class="login-form">
                          <form @submit.prevent>
                            <h3 class="inputtitle">Two-factor Authentication</h3>
                            <div class="input-group">
                              <input type="number" required v-model="otpInput">
                              <label>Enter OTP</label>
                            </div>
                            <p v-if="showTimer">Time left: {{ formattedTimer }} </p>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding footer-section">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline" v-if="!timer">
                                <div class="forgot-pswd" @click="resend">
                                  <h4>Resend OTP</h4>
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding spl_inlineblock floatright">
                                <div class="button-style">
                                  <button type="button" @click="submit" class="primary-btn login-btn">
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div :class="['login-form', {'pt-10': remainingAttempts !== -1 }]" v-if="viewLogin && !showOTPForm">
                        <form>
                          <div v-if="remainingAttempts >= 1" class="login-error text-left mb-15">
                            <span class="login-error-header" v-if="error">{{$t('EMAIL_OR_PASSWORD_INCORRECT')}}</span>
                            <span class="login-error-header" v-if="error_password">{{$t('PASSWORD_INCORRECT')}}</span>
                            <div class="login-error-body">
                              <p class="d-inline-default">{{$t('REMAINING_ATTEMPTS')}} : </p><span>{{remainingAttempts}}</span>
                              <p><span class="fw-600">{{$t('LOGIN_WARNING')}} : </span>{{$t('AFTER')}} <span class="fw-600">{{remainingAttempts}} {{$t('CONSECUTIVE')}}</span> {{$t('UNSUCCESSFUL_LOGIN_WARNING_TEXT')}}</p>
                            </div>
                          </div>
                          <span class="error" v-if="(error || error_password) && remainingAttempts === -1">Invalid Credentials</span>
                          <div class="input-group">
                            <input type="text" required v-model="email">
                            <label>User name:</label>
                          </div>
                          <div class="input-group">
                            <Input type="password" v-model="password" required id="pass">
                              <i
                                class="el-input__icon"
                                slot="suffix"
                                @click="showHide()"
                                >
                                <svgicon :name="icon" width="14" height="14"/>
                              </i>
                            </Input>
                            <label>Password:</label>
                          </div>
                          <div class="captcha-wrapper" v-if="enableCaptcha && (!validCaptcha && siteKey)">
                              <div class="captcha-vertical-center">
                                <h2 class="sub-head mt-0"> Verify Captcha </h2>
                                <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                                  :loadRecaptchaScript="true" :sitekey="`${siteKey}`" />
                              </div>
                            </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding footer-section" v-if="(!enableCaptcha || (enableCaptcha && validCaptcha))">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline">
                              <div class="forgot-pswd" @click="viewForgotPassword()">
                                <h4 style="color: #003D31 !important;">Forgot Password?</h4>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inlineblock floatright">
                              <div class="button-style">
                                <button type="button" @click="login" class="primary-btn login-btn">
                                    Log in
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="login-form reset" v-else-if="resetPasswordResponse">
                        <h3 class="inputtitle text-md">CHECK EMAIL FOR OTP</h3>
                        <div class="login-info">
                          A message has been sent to you by email with new OTP.
                        </div>
                          <div class="col-lg-6 col-md-6
                            col-sm-6 col-xs-12 no-padding">
                            <div class="button-style f-left">
                              <button type="button" @click="viewLoginScreen" class="primary-btn login-btn">
                                  LOGIN
                              </button>
                            </div>
                          </div>
                      </div>
                      <div class="login-form" v-else-if="!showOTPForm">
                        <form>
                          <h3 class="inputtitle">FORGOT PASSWORD</h3>
                          <div class="input-group">
                            <input type="text" required v-model="email"
                              v-on:keyup.13="resetPassword">
                            <label>Enter registered email address:</label>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding footer-section">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding dspl_inline">
                              <div class="forgot-pswd" @click="viewLoginScreen()">
                                <h4 style="color: #003D31 !important;">Back to login</h4>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-padding spl_inlineblock floatright">
                              <div class="button-style">
                                <button type="button" @click="resetPassword" class="primary-btn login-btn">
                                    Reset password
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="login-disclaimer">
                        {{ $t('PANDO_PRIVACY_POLICY') }}
                      </div>
                      <div class="login-privacy-policy" @click="viewPrivacyPolicy()">
                        <h4>
                          Pando Privacy Policy
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-6 col-xs-12 no-padding logo-bg">
                    <div class="radius-right" style="height: 100%;">
                      <img :src="Bg" class="img-responsive" alt=""  style="height: 100%; width: auto; border-radius:0 14px 14px 0px;"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from '@common/asset/images/logo.svg';
import Bg from '@common/asset/images/Sign_In.jpg';
import LoginValidation from '@/components/mixins/Login';
import setLocale from '@/utils/localisation';
import VueRecaptcha from 'vue-recaptcha';
import { isNumber } from 'lodash';

export default {
  data() {
    return {
      email: null,
      password: null,
      Logo,
      Bg,
      error: false,
      error_password: false,
      viewLogin: true,
      resetPasswordResponse: null,
      icon: 'icon-eye-view',
      attempts: 0,
      validCaptcha: false,
      showOTPForm: false,
      otpInput: '',
      showTimer: false,
      timer: 0,
      timeLeft: 0,
      endTime: 0,
      remainingAttempts: -1,
    };
  },
  mixins: [LoginValidation],
  components: {
    VueRecaptcha,
  },
  computed: {
    ...mapGetters({
      environmentVariables: 'app/environmentVariables',
      isPaymentError: 'app/getIsPaymentError',
    }),
    enableCaptcha() {
      // return this.environmentVariables.rc_enabled === 'true' || this.environmentVariables.rc_enabled === true;
      return (this.environmentVariables.rc_enabled === 'true' || this.environmentVariables.rc_enabled === true) && this.attempts >= 3;
    },
    showDownTimeWarning() {
      const isEnabled = (this.environmentVariables.is_warning_message === 'true' || this.environmentVariables.is_warning_message === true) || false;
      return isEnabled;
    },
    showDownTimeMessage() {
      return (this.environmentVariables && this.environmentVariables.show_message) || '';
    },
    showDownTimeSubMessage() {
      return (this.environmentVariables && this.environmentVariables.mail_to) || '';
    },
    siteKey() {
      return this.environmentVariables.rc_site_key;
    },
    formattedTimer() {
      if (this.timeLeft >= 0) {
        const minutes = Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((this.timeLeft % (1000 * 60)) / 1000);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      }
    },
  },
  destroyed() {
    clearInterval(this.timerTimeout);
  },
  async created() {
    if (this.isPaymentError) {
      this.$errorMessage({ message: 'Payment Required.' });
    }
    const key = `${window.location.host}-attempts`;
    this.attempts = JSON.parse(localStorage.getItem(key)) || 0;
    await setLocale('en');
  },
  methods: {
    showHide() {
      const x = document.getElementById('pass');
      if (x.type === 'password') {
        x.type = 'text';
        this.icon = 'icon-eye-hide';
      } else {
        x.type = 'password';
        this.icon = 'icon-eye-view';
      }
    },
    viewForgotPassword() {
      this.viewLogin = false;
      this.resetPasswordResponse = null;
    },
    viewLoginScreen() {
      this.viewLogin = true;
      this.resetPasswordResponse = null;
    },
    async resetPassword() {
      try {
        const data = { email: this.email };
        const result = await this.$store.dispatch('app/forgotPassword', {
          data,
        });
        if (result.status === 404) {
          this.$errorMessage({
            message: 'No account is found with the given email address',
          });
        } else if (result && result.data && result.data.errors) {
          this.$errorMessage({ message: result.data.errors[0].message });
        } else {
          this.resetPasswordResponse = true;
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    startTimer() {
      const time = new Date().getTime();
      const newTime = Math.ceil(time / 1000) * 1000;
      this.endTime = newTime + (this.timer * 1000);
      const startTime = new Date().getTime();
      this.timeLeft = this.endTime - startTime;

      this.timerTimeout = setInterval(() => {
        if (this.timeLeft > 0) {
          const currentTime = new Date().getTime();
          this.timeLeft = this.endTime - currentTime;
        } else {
          clearInterval(this.timerTimeout);
          this.endTime = 0;
          this.showTimer = false;
          this.timeLeft = 0;
          this.timer = 0;
          this.timerId = setTimeout(() => {
            this.showOTPForm = false;
            this.otpInput = '';
            localStorage.setItem('tsm-transporter-token', '');
          }, 30000);
        }
      }, 1000);
    },
    viewPrivacyPolicy() {
      window.open('https://pando.ai/privacy.php', '_blank');
    },
    async submit() {
      const optAuth = localStorage.getItem('otp-auth-token');
      const data = { otp: this.otpInput, secretKey: optAuth };
      const result = await this.$store.dispatch('app/verifyToken', {
        data,
      });
      localStorage.setItem('otp-verified', false);
      if (result.tokenVerified) {
        const key = `${window.location.host}-attempts`;
        localStorage.setItem('otp-verified', true);
        await this.redirect(key);
      } else {
        this.$errorMessage({ message: 'Invalid OTP' });
      }
    },
    async resend() {
      localStorage.setItem('otp-auth-token', '');
      const data = { email: this.email };
      const result = await this.$store.dispatch('app/generateToken', {
        data,
      });
      if (result.otpAuthToken) {
        clearTimeout(this.timerId);
        this.showTimer = true;
        this.timer = result.otp_timer || 0;
        this.showOTPForm = true;
        localStorage.setItem('otp-auth-token', result.otpAuthToken);
        this.startTimer();
      }
    },
    async login() {
      try {
        const { email, password } = this;
        const tableParameters = localStorage.getItem('tableParameters');
        // localStorage.clear();
        if (tableParameters) {
          localStorage.setItem('tableParameters', tableParameters);
        }
        const result = await this.$store.dispatch('app/login', { email, password });
        const token = localStorage.getItem('tsm-transporter-token');
        const key = `${window.location.host}-attempts`;
        if (result.otpAuthToken) {
          this.attempts = 0;
          this.showTimer = true;
          this.timer = result.otp_timer || 0;
          localStorage.setItem(key, JSON.stringify(0));
          this.showOTPForm = true;
          localStorage.setItem('otp-verified', false);
          localStorage.setItem('otp-auth-token', result.otpAuthToken);
          this.startTimer();
        }
        if (result === '' && token) {
          await this.redirect(key);
        } else if (result.status === 401) {
          this.updateLoginAttempts(key);
          this.error = false;
          this.error_password = true;
          this.remainingAttempts = isNumber(result.data.remainingAttempts) ?
            result.data.remainingAttempts : -1;
        } else if (result.status === 402) {
          this.$router.push({ name: 'Login' });
          this.$errorMessage({ message: 'Payment Required' });
        } else if (result.status === 404) {
          this.updateLoginAttempts(key);
          this.error = true;
          this.error_password = false;
        } else if (result.status === 400) {
          this.remainingAttempts = isNumber(result.data.remainingAttempts) ?
            result.data.remainingAttempts : -1;
          if (this.remainingAttempts === 0) {
            this.viewForgotPassword();
          } else {
            this.$errorMessage({ message: result.data.errors[0].message });
          }
        }
        return false;
      } catch (err) {
        throw err;
      }
    },
    async redirect(key) {
      this.attempts = 0;
      localStorage.setItem(key, JSON.stringify(0));
      const bootstrapData = await this.$store.dispatch('app/bootstrap');
      this.validateRedirect(bootstrapData);
      if (bootstrapData && bootstrapData.current_user && this.environmentVariables.rtly_site_key) {
        const vueContainer = document.getElementById('retently-survey-embed');
        if (vueContainer) {
          vueContainer.setAttribute(
            'data-href',
            `https://app.retently.com/api/remote/tracking/${this.environmentVariables.rtly_site_key}`,
          );
          vueContainer.setAttribute('data-rel', 'dialog');
          vueContainer.setAttribute('data-campaign', 'regular');
          vueContainer.setAttribute('data-email', bootstrapData.current_user.email || '-');
          vueContainer.setAttribute('data-firstname', bootstrapData.current_user.name || '-');
          vueContainer.setAttribute('data-lastname', '-');
          vueContainer.setAttribute('data-company', bootstrapData.clients[0].name || '-');
          vueContainer.setAttribute('data-tags', 'transporter');
          const script = document.createElement('script');
          script.innerHTML = (function (d, s, id) {
            const rjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            const js = d.createElement(s);
            js.id = id;
            js.src = 'https://cdn.retently.com/public/components/embed/sdk.min.js';
            rjs.parentNode.insertBefore(js, rjs);
          }(document, 'script', 'retently-jssdk'));
          document.head.appendChild(script);
        }
      }
    },
    async onCaptchaVerified(recaptchaToken) {
      try {
        const response = await this.$store.dispatch('app/reCaptchaVerify', recaptchaToken);
        if (response && response.data && response.data.success) {
          this.validCaptcha = true;
        } else {
          this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
        }
      } catch (error) {
        throw error;
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    updateLoginAttempts(key) {
      const storedAttempts = JSON.parse(localStorage.getItem(key));
      this.validCaptcha = false;
      if (storedAttempts) {
        localStorage.setItem(key, (parseInt(storedAttempts, 10) + 1).toString());
        this.attempts = (parseInt(storedAttempts, 10) + 1);
      } else {
        localStorage.setItem(key, 1);
        this.attempts = 1;
      }
    },
  },
};
</script>

<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

#header {
    width: 100%;
    padding: 0;
    float: left;
    height: 100vh;
}
.parallaxbg {
    background-image: url(~@common/asset/images/login_bg.jpg);
    // margin: -120px -20px -20px -20px !important;
    width: 100%;
    margin: 0 auto;
    background-position: center center;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    overflow: hidden;
}
.login-btn {
  background-color: #077D8A !important;
  border: 1px solid #077D8A !important;
  border-radius: 4px !important;
}
.section-overly {
    min-height: 100vh;
    .no-padding {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .dspl_inline {
        display: inline;
    }
    .dspl_inlineblock {
        display: inline-block;
    }
    .outer-text {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
    }
    .middle-text {
        display: table;
        width: 100%;
        height: 100%;
    }
    .inner-text {
        display: table-cell;
        vertical-align: middle;
    }
    form {
        input {
            width: 100%;
            border: 0;
            border-bottom: 1px solid #9B9B9C;
            padding: 16px 0 9px;
            font-family:$fontSemibold;
            font-size: 12px;
            color: #404040;
            &:focus {
                outline: none;
                border-bottom: 1px solid #003F91;
            }
        }
        .input-group {
            position: relative;
            width: 100%;
            margin: 10px 0 20px;
            label {
                content: attr(data-placeholder);
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                -webkit-transform: translate(0%, -50%);
                transform: translate(0%, -50%);
                -webkit-transition: all 0.3s ease-in-out;
                transition: all 0.3s ease-in-out;
                background-color: rgba(255, 255, 255, 0);
                color: #404040;
                font-size: 10px;
                font-weight: normal;
                line-height: 10px;
                text-transform: uppercase;
                input[type="text"],
                input[type="password"] {
                    border-bottom: 1px solid #9999a3;
                }
                input[type="text"]:focus,
                input[type="text"]:valid,
                input[type="password"]:focus,
                input[type="password"]:valid {
                    border-bottom: 1px solid #9B9B9C;
                }
                input:focus~label,
                input:valid~label {
                    top: -1px;
                    color: #404040;
                    font-size: 10px;
                    font-weight: normal;
                    line-height: 10px;
                    text-transform: uppercase;
                }
            }
        }
    }
    .modal-wrap {
        max-width: 1000px;
        margin: 0 auto;
        border-radius: 10px;
        box-shadow: 3px 3px 10px 0 #01314f;
        -webkit-transition: -webkit-transform 300ms ease-in-out;
        transition: -webkit-transform 300ms ease-in-out;
        transition: transform 300ms ease-in-out;
        transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;
        .modal-bodies {
            position: relative;
            -webkit-perspective: 1000px;
            perspective: 1000px;
        }
    }
    .login-page form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .login-wrap {
        box-shadow: 5px 0 10px 1px rgba(0, 0, 0, 0.1);
        background: #fff;
        border-radius: 4px 2px 2px 4px;
        height: 502px;
        .login-header {
            padding: 30px 20px 20px 30px;
            text-align: left;
        }
        .login-form {
            padding: 50px;
        }
        .border-line {
            border: 2px solid #008AFF;
            float: left;
            width: 47px;
            margin: 0 30px;
        }
    }
    .footer-section {
        margin: 2px 0;
        .forgot-pswd {
            text-align: left;
            display: inline-block;
        }
        .forgot-pswd h4 {
          float: left;
          margin: 0;
          color: #008AFF !important;
          font-size: 1.0rem;
          line-height: 26px;
          cursor: pointer;
        }
    }

    .conditions {
        padding: 0 50px 30px;
        vertical-align: bottom;
        position: relative;
        h5 {
            color: #008AFF;
            font-family:$fontSemibold;
            font-size: 10px;
            text-align: left;
        }
        p {
            color: #929292;
            font-size: 9px;
            letter-spacing: 0.23px;
            text-align: left;
        }
    }

    .error {
      font-size: 11px;
      width: 100%;
      text-align: left;
      color: #DD3A3A;
      padding: 8px 0 0 0;
    }
}
.logo-bg img{
  width: 100%;
}
.captcha-wrapper {
    height: 100%;
    position: fixed;
    top: 15%;
    transform: translateX(-50%);
    .captcha-vertical-center {
      width: 345px;
      padding: 20px;
      margin-left: -172px;
      position: absolute;
      top: 48%;
      left: 0;
      border-radius: 4px;
      box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.06);
      transform: translateY(-48%);
    }
  }
</style>
